
<template>
  <div>
    <data-list class="select_checkbox_column_width_0" :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="750" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '../../components/DataList.vue'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: { isactive: true },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        page: 1,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.TICKETTYPE_INDEX) ? this.$store.state.TICKETTYPE_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'tickettypes'
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '30%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }, {
        text: this.$t('message.common.isDefault'),
        value: 'isdefault',
        isBoolean: true,
        sortable: false,
        width: '20%'
      }/* , {
        text: this.$t('message.common.position'),
        value: 'position',
        sortable: true,
        width: '20%'
      } */]
    },
    ...mapState(['FORM_TYPE']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.tickets.updateType') : this.$t('message.tickets.createType'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs6'
        }, /* {
          model: 'position',
          rules: [],
          type: this.FORM_TYPE.NUMBER,
          class: 'xs6',
          label: this.$t('message.common.position')
        },  */{
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs3 my-auto',
          label: this.$t('message.common.isActive')
        }, {
          model: 'isdefault',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'xs3 my-auto',
          label: this.$t('message.common.isDefault')
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = {
          type: 'TICKETTYPE_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      let queryFields = this.$formatter.cloneVariable(this.headers)
      let { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let query = {
        'order_by': {
          'field': sortBy.join(''),
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE}/query`, query)
        .then((response) => {
          let { values, count } = response.data
          this.listPayloadObj.loading = false
          this.listPayloadObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.listPayloadObj.page = 1
          }
        })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE}/${id}`)
        .then((result) => {
          if (result.data) this.modelObj = result.data
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.modelObj.isactive = true
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        model.position = model.position || null
        let url = this.MODULE
        this.$_saveUpdateHandler(url, model)
          .then(() => {
            this.closeDialogHandler()
            this.getListHandler()
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
